import React from 'react';
import { Table, Form, OverlayTrigger, Tooltip, Dropdown, Button } from 'react-bootstrap';

const AllTimesheetsTable = ({
    onEdit,
    onMoveOrCopy,
    onLogTime,
    onViewHistory,
    onAddSubtasks,
    onView,
    onDuplicate,
    onDelete,
    onEstimateTime
}) => {
    const [expandedRows, setExpandedRows] = React.useState(new Set());

    const toggleRow = (index) => {
        const newExpandedRows = new Set(expandedRows);
        if (newExpandedRows.has(index)) {
            newExpandedRows.delete(index);
        } else {
            newExpandedRows.add(index);
        }
        setExpandedRows(newExpandedRows);
    };
    return (
        <Table responsive className='c-table'>
            <thead>
                <tr>
                    <th width="250px">Task</th>
                    <th width="250px">Logged by</th>
                    <th width="120px" className='text-center'>Date</th>
                    <th width="120px" className='text-center'>Time Logged</th>
                    <th>Description</th>
                    <th width="50px" className='text-center'>Actions</th>
                </tr>
            </thead>
            <tbody>
                {[...Array(5)].map((_, i) => (
                    <React.Fragment key={i}>
                        <tr>
                            <td className='fw-bold' colSpan={6}>11 Aug 2025</td>
                        </tr>
                        <tr>
                            <td>
                                <div className='p-tag fw-bold'>Home Page</div>
                                <div className='p-tag fs-12'>Backend Tasks</div>
                                <div className='p-tag fs-12'>Netclues Technologies PVT LTD</div>
                            </td>
                            <td>
                                <div className='d-flex align-items-center'>
                                    <div className='c-avatar'>
                                        <img src='https://randomuser.me/api/portraits/men/32.jpg' alt='Avatar' />
                                    </div>
                                    <div>
                                        <div className='p-tag fw-bold'>John Doe</div>
                                        <div className='p-tag fs-12'>Role: Team Lead</div>
                                    </div>
                                </div>
                            </td>
                            <td className='text-center'>
                                01 Aug 2025 <br/>at 10:00 AM
                            </td>
                            <td className='text-center'>
                                6h 30m
                            </td>
                            <td>
                                I have reviewed the code and submitted it to the development team.
                            </td>
                            <td className='text-center'>
                                <Dropdown className='c-dropdown-1'>
                                    <Dropdown.Toggle variant="link" id="dropdown-basic">
                                        <i className="fas fa-ellipsis-v"></i>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={onEdit}><i className="fas fa-edit me-2"></i> Edit</Dropdown.Item>
                                        <Dropdown.Item onClick={onDelete}><i className="fas fa-trash me-2"></i> Delete</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div className='p-tag fw-bold'>Home Page</div>
                                <div className='p-tag fs-12'>Backend Tasks</div>
                                <div className='p-tag fs-12'>Netclues Technologies PVT LTD</div>
                            </td>
                            <td>
                                <div className='d-flex align-items-center'>
                                    <div className='c-avatar'>
                                        <img src='https://randomuser.me/api/portraits/men/32.jpg' alt='Avatar' />
                                    </div>
                                    <div>
                                        <div className='p-tag fw-bold'>John Doe</div>
                                        <div className='p-tag fs-12'>Role: Team Lead</div>
                                    </div>
                                </div>
                            </td>
                            <td className='text-center'>
                                01 Aug 2025 <br/>at 10:00 AM
                            </td>
                            <td className='text-center'>
                                6h 30m
                            </td>
                            <td>
                                I have reviewed the code and submitted it to the development team.
                            </td>
                            <td className='text-center'>
                                <Dropdown className='c-dropdown-1'>
                                    <Dropdown.Toggle variant="link" id="dropdown-basic">
                                        <i className="fas fa-ellipsis-v"></i>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={onEdit}><i className="fas fa-edit me-2"></i> Edit</Dropdown.Item>
                                        <Dropdown.Item onClick={onDelete}><i className="fas fa-trash me-2"></i> Delete</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </td>
                        </tr>
                        <tr>
                            <td className='fw-bold' colSpan={3}></td>
                            <td className='fw-bold text-center'>8h 30m</td>
                            <td className='fw-bold' colSpan={2}></td>
                        </tr>
                    </React.Fragment>
                ))}
            </tbody>
        </Table>
    );
};

export default AllTimesheetsTable;
